import PropTypes from 'prop-types'
import React, { Component } from 'react'

export default class ErrorPopup extends Component {
  render() {
    const errorText = this.props.error
    return (
      <p className={`xs-mb4 xs-text-red ${this.props.extraClasses}`}>{errorText}</p>
    )
  }
}

ErrorPopup.propTypes = {
  error: PropTypes.string,
  extraClasses: PropTypes.string,
}

ErrorPopup.defaultProps = {
  error: PropTypes.string,
  extraClasses: '',
}



// WEBPACK FOOTER //
// ./src/components/error-popup/error-popup.js